// extracted by mini-css-extract-plugin
export var askAiIcon = "_qm-9";
export var container = "_qm-0";
export var groupSeparator = "_qm-a";
export var highlight = "_qm-4";
export var resultIcon = "_qm-5";
export var resultItem = "_qm-7";
export var resultSubtitle = "_qm-3";
export var resultTitle = "_qm-2";
export var resultsList = "_qm-1";
export var searchGroup = "_qm-6";
export var selected = "_qm-8";